(() => {
	const btn = document.querySelector('[data-back-to-top]');
	if (!btn) return;

	const toggle = () => {
		if (window.scrollY > 400) {
			btn.classList.add('is-visible');
		} else {
			btn.classList.remove('is-visible');
		}
	};

	btn.addEventListener('click', (e) => {
		e.preventDefault();
		window.scrollTo({ top: 0, behavior: 'smooth' });
	});

	window.addEventListener('scroll', toggle, { passive: true });
	toggle();
})();
